import Vue from 'vue';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
import { http } from './util/http'
import Vuex from 'vuex'
/*
var VueTouch = require('vue-touch')
Vue.use(VueTouch, {name: 'v-touch'})
*/

Vue.config.productionTip = false;

new Vue({
  router,
  vuetify,
  render: h => h(App),
}).$mount('#app');


